import DOMPurify from "dompurify";
import {useRef} from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from 'react-bootstrap/Form';
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {LocaleSelector} from "../common/LocaleSelector";
import {SavedLocation} from "./SavedLocation";
import {XSRF} from "./Xsrf";

export const PortalLogin = () =>
{
    const [searchParams] = useSearchParams();

    /**
     * A ref to the hidden _csrf form field
     */
    const csrFieldRef = useRef<HTMLInputElement>(null);

    const loginURL: string = "/api/login"

    /**
     * i18next translation hook
     */
    const {t} = useTranslation(['translation', 'override']);

    const sanitizeHTML = (html : string) => {
        return {__html: DOMPurify.sanitize(html)};
    }

    // back-end will add the logout parameter when the user is logged out
    if (searchParams.has("logout")) {
        SavedLocation.clearSavedLocation();
    }

    function onSubmit()
    {
        if (csrFieldRef.current !== null) {
            csrFieldRef.current.value = XSRF.generateCookie();
        }
    }

    return (
        <Form method="post" action={loginURL} onSubmit={onSubmit} className="w-100 p-4 shadow-sm rounded bg-white">
            <div className="mb-4 text-center">
                <h2>{t("login.please-login")}</h2>
            </div>

            {searchParams.has("error") && <Alert variant="danger">{t('portal.login.login-failure')}</Alert>}

            <FloatingLabel label={t('portal.login.email-label')} className="text-secondary mb-3">
                <Form.Control type="email" name="username" placeholder="Email"/>
            </FloatingLabel>

            <FloatingLabel label={t('portal.login.password-label')} className="text-secondary mb-3">
                <Form.Control type="password" name="password" placeholder="Password"/>
            </FloatingLabel>

            <a href="/forgot-password">{t('portal.login.forgot-password')}</a>

            <Button variant="success" type="submit" className="w-100 mt-4">
                {t("portal.login.login-button")}
            </Button>

            <LocaleSelector className="w-auto mt-4" />

            {t('override:portal.legal-notice', '').length > 0 &&
                <div className="mt-2" dangerouslySetInnerHTML={sanitizeHTML(t(["override:portal.legal-notice"]))} />
            }

            <input name="_csrf" type="hidden" ref={csrFieldRef} value=""/>
        </Form>
    );
}
